import { useEffect, useState } from 'react';
import axios from 'axios';

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const cache = new Map();
const TTL_MS = 60_000;

function load(ticker) {
  const hit = cache.get(ticker);
  if (hit && Date.now() - hit.at < TTL_MS) return hit.promise;
  const promise = axios.get(`${API}/stocks/${ticker}/dividend-schedule`, { withCredentials: true })
    .then((r) => r.data)
    .catch(() => { cache.delete(ticker); return null; });
  cache.set(ticker, { at: Date.now(), promise });
  return promise;
}

// One request per ticker shared by the top payment cards and Recent Events.
export default function useDividendSchedule(ticker) {
  const [state, setState] = useState({ data: null, loading: true });
  useEffect(() => {
    if (!ticker) return undefined;
    let cancelled = false;
    setState({ data: null, loading: true });
    load(ticker).then((data) => { if (!cancelled) setState({ data, loading: false }); });
    return () => { cancelled = true; };
  }, [ticker]);
  return state;
}
